import React from 'react'

type UiPreviewCanvasProps = {
  title: string
  description: string
  stageClassName?: string
  children: React.ReactNode
}

const UiPreviewCanvas: React.FC<UiPreviewCanvasProps> = ({
  title,
  description,
  stageClassName,
  children,
}) => {
  const stageClassNames = ['ui-preview__stage', stageClassName]
    .filter(Boolean)
    .join(' ')

  return (
    <main className="ui-preview">
      <header className="ui-preview__header">
        <h2 className="ui-preview__title">{title}</h2>
        <p className="ui-preview__description">{description}</p>
      </header>

      <section className="ui-preview__canvas" aria-label={`${title} preview`}>
        <div className={stageClassNames}>{children}</div>
      </section>
    </main>
  )
}

export default UiPreviewCanvas
